import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";

firebase.initializeApp({
  apiKey: "AIzaSyDGDO43wHVVMY6sEQvYIxp0_sJT_JUwxxE",
  authDomain: "toocool-website.firebaseapp.com",
  projectId: "toocool-website",
  storageBucket: "toocool-website.appspot.com",
  messagingSenderId: "596595736787",
  appId: "1:596595736787:web:bd7bf9a980d3a614ae9426",
  measurementId: "G-119MZ53FT3",
});

export const db = firebase.database();
export const productsRef = db.ref("products");
export const collectionsRef = db.ref("collections");
export const typesRef = db.ref("types");
export const ordersRef = db.ref("orders");
